<template>
    <span class="font-bold text-sm">{{ date }}</span>
</template>

<script>
    export default {
        name: "Date",
        props: ['date']
    }
</script>

<style scoped>

</style>